import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
    <p
        className={`font-mono text-xs uppercase tracking-[0.3em] font-semibold text-gold ${className}`}
    >
        {children}
    </p>
);

export const SectionHeading = ({ eyebrow, title, dark = false, className = "" }) => (
    <div className={className}>
        <Reveal>
            <Eyebrow>{eyebrow}</Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
            <h2
                className={`mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.12] ${
                    dark ? "text-white" : "text-navy"
                }`}
            >
                {title}
            </h2>
        </Reveal>
    </div>
);
